import { render, staticRenderFns } from "./DetailsTicketRequest.vue?vue&type=template&id=ac01bff8&scoped=true&"
import script from "./DetailsTicketRequest.vue?vue&type=script&lang=ts&"
export * from "./DetailsTicketRequest.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsTicketRequest.vue?vue&type=style&index=0&id=ac01bff8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac01bff8",
  null
  
)

export default component.exports